import React from "react";
import "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faReact,
  faJava,
  faDocker,
  faPython,
  faVimeo,
} from "@fortawesome/free-brands-svg-icons";
import Chip from "@mui/material/Chip";
import "../assets/styles/Expertise.scss";

const labelsFirst = [
  "React",
  "Next.js",
  "Angular",
  "Vue",
  "Svelte",
  "Solid.js",
  "TypeScript",
  "HTML5",
  "CSS3",
  "Tailwind CSS",
  "Material UI",
  "Chakra UI",
  "Styled Components",
  "Three.js",
  "GSAP",
  "Framer Motion",
  "Responsive Design",
  "UI/UX Design",
  "Figma",
];

const labelsSecond = [
  "Java",
  "Node.js",
  "Python",
  "PHP",
  "REST API Design",
  "GraphQL",
  "Microservices Architecture",
  "Event-Driven Systems",
];

const labelsThird = [
  "AWS",
  "GCP",
  "Azure",
  "Docker",
  "Kubernetes",
  "Terraform",
  "Jenkins",
  "GitHub Actions",
  "CircleCI",
  "CI/CD Automation",
  "Blue-Green Deployments",
];

const labelsFourth = [
  "TensorFlow",
  "PyTorch",
  "Machine Learning",
  "AI Automation",
  "Deep Learning",
  "LLMs (OpenAI, Claude)",
  "Prompt Engineering",
  "LangChain",
  "Vector Databases",
  "RAG Systems",
  "AI API Integration",
  "OpenAI API",
  "HuggingFace",
];

const labelsFifth = [
  "Image Processing",
  "Video Processing",
  "Audio Processing",
  "FFmpeg",
  "OpenCV",
  "Media Encoding & Compression",
  "Speech-to-Text / Text-to-Speech",
];

function Expertise() {
  return (
    <div className="container" id="expertise">
      <div className="skills-container">
        <h1>EXPERTISE</h1>
        <div className="skills-grid">
          <div className="skill">
            <FontAwesomeIcon icon={faReact} size="3x" />
            <h3>Frontend Development</h3>
            <p>
              I have strong frontend and frontend design experience building
              user interfaces that are clear, responsive, and easy to use. I’ve
              worked on real products, turning designs and wireframes into fully
              functional pages while ensuring visual consistency and usability.
              I focus on clean layouts, intuitive user flows, smooth
              interactions, and thoughtful design details that make applications
              feel simple and engaging for users.
            </p>
            <div className="flex-chips">
              {labelsFirst.map((label, index) => (
                <Chip key={index} className="chip" label={label} />
              ))}
            </div>
          </div>

          <div className="skill">
            <FontAwesomeIcon icon={faJava} size="3x" />
            <h3>Backend Development</h3>
            <p>
              I have solid backend experience building services that handle
              data, business logic, and integrations. I’ve worked with APIs,
              databases, authentication, background jobs, and system
              integrations in production environments. I focus on keeping
              backend systems clear, reliable, and easy to support long term.
            </p>
            <div className="flex-chips">
              {labelsSecond.map((label, index) => (
                <Chip key={index} className="chip" label={label} />
              ))}
            </div>
          </div>

          <div className="skill">
            <FontAwesomeIcon icon={faDocker} size="3x" />
            <h3>DevOps Skills</h3>
            <p>
              I have DevOps experience supporting deployments and keeping
              systems running smoothly. I’ve worked with cloud environments,
              automated builds, deployments, and monitoring, and helped fix
              issues in live systems. I focus on simple setups, clear processes,
              and making sure releases go out safely.
            </p>
            <div className="flex-chips">
              {labelsThird.map((label, index) => (
                <Chip key={index} className="chip" label={label} />
              ))}
            </div>
          </div>

          <div className="skill">
            <FontAwesomeIcon icon={faPython} size="3x" />
            <h3>AI Skills</h3>
            <p>
              I have hands-on experience building and integrating AI solutions
              into real-world applications. I’ve worked with machine learning
              models, large language models, and automation tools to solve
              business problems and improve workflows. I focus on practical AI
              use cases, scalable implementations, and making AI systems
              reliable and production-ready.
            </p>
            <div className="flex-chips">
              {labelsFourth.map((label, index) => (
                <Chip key={index} className="chip" label={label} />
              ))}
            </div>
          </div>

          <div className="skill">
            <FontAwesomeIcon icon={faVimeo} size="3x" />
            <h3>Multimedia Processing Skills</h3>
            <p>
              I have experience working with multimedia content including
              images, audio, and video processing. I’ve built systems that
              analyze, transform, and optimize media for web and AI
              applications. I focus on performance, automation, and delivering
              high-quality media pipelines for production environments.
            </p>
            <div className="flex-chips">
              {labelsFifth.map((label, index) => (
                <Chip key={index} className="chip" label={label} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Expertise;
